import { AscReportListContainer } from './containers'
import { role } from '@/utilities/userRoles'

const reportsRouter = {
  icon: 'mdi-file',
  path: '/reports',
  name: 'Reports',
  component: AscReportListContainer,
  display: true,
  meta: {
    primaryNavigation: true,
    requiresRole: role.acmfUser,
    tooltip: 'View reports',
    breadcrumbs: [
      {
        text: 'Home',
        to: '/',
      },
      {
        text: 'ACMF Reports',
      },
    ],
  },
  children: [],
}

export default reportsRouter
